import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";
import EventCreate from "../components/eventCreate";

const CreateEvent = () => {
  useTitle("- Create Event");

  return (
    <div>
      <Navbar />
        <EventCreate /> 
      <Footer />
    </div>
  );
};

export default CreateEvent;
